import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core'
import { NgStyle } from '@angular/common';
import { ActivatedRoute } from '@angular/router'
import { SubscriptionsService } from '@appShared/services/subscriptions.service'
import { RegistrationProduct } from '@appShared/services/registrations.service'
import { IUser } from '@appShared/interfaces/[Interface-based]/user.interface'
import * as _ from 'lodash'
import { environment } from '@appEnvironments/environment'

@Component({
    selector: 'app-registration-landing',
    templateUrl: './registration-landing.component.html',
    styleUrls: ['./registration-landing.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None /*Needed to override base body element (grandfather element)*/,
    imports: [NgStyle]
})
export class RegistrationLandingComponent implements OnInit {
   user: IUser
   tokenData: string
   _registrationProducts = environment.registrationProducts;
   registrationProduct: RegistrationProduct
   isLoading = true;
   defaultBackgroundColor = 'rgba(255, 255, 255, 0.5)';
   defaultColor = 'inherit';

   constructor(
      private _subscriptionsService: SubscriptionsService,
      private _activatedRoute: ActivatedRoute,
      private _cd: ChangeDetectorRef
   ) {
   }

   ngOnInit() {
      this.isLoading = true
      this.tokenData = this._activatedRoute.snapshot.queryParamMap.get('token')
      this._getTokenData()
   }

   /*
   * private methods
   * */

   private _getTokenData() {

      this._subscriptionsService
         .getProductFromToken(this.tokenData)
         .then(tokenProduct => {
            const productSourceId = tokenProduct?.sourceId || ''
            this.registrationProduct = this._registrationProducts.find(
               registrationProduct => registrationProduct.productSourceId === productSourceId
            )

            this._setRegistrationSites()

            /* if only 1 site...and showLandingIfSingle - then redirect */
            const registrationSites = this.registrationProduct.registrationSites
            if (registrationSites.length === 1 && !this.registrationProduct.showLandingIfSingle) {
               window.location.href = registrationSites[0].uri
            }
         })
         .catch(() => {
            this._setRegistrationSites()
         })
         .finally(() => {
            this.isLoading = false
         })
   }

   private _setRegistrationSites() {

      if (!this.registrationProduct) {
         this.registrationProduct = this._registrationProducts.find(
            registrationProduct => !registrationProduct.productSourceId
         )
      }

      /* append token to Uri if exist */
      this.registrationProduct.registrationSites.forEach(site => {
         if (site.appendToken) {

            if (this.tokenData) {
               site.uri = `${site.uri}${site.uriSuffix}${encodeURIComponent(this.tokenData)}`
            } else {
               site.uri = `${site.uri}${site.uriSuffix}`
            }

         } else {
            site.uri = `${site.uri}${site.uriSuffix}`
         }
      })

      this._cd.markForCheck()
   }

   /*
   * public methods
   * */

}
